import React, { Component } from 'react';
import './App.css';

import lightBaseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import {MuiThemeProvider, getMuiTheme} from 'material-ui/styles';
import injectTapEventPlugin from 'react-tap-event-plugin';
injectTapEventPlugin(); // Needed for onTouchTap http://stackoverflow.com/a/34015469/988941

import {
  AppBar,
  Avatar,
  Card,
  CardActions,
  CardText,
  CardTitle,
  DatePicker,
  Dialog,
  Divider,
  Drawer,
  FlatButton,
  FloatingActionButton,
  FontIcon,
  List,
  ListItem,
  makeSelectable,
  Menu,
  MenuItem,
  RaisedButton,
  Subheader,
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
  TextField,
  Paper,
} from 'material-ui';

import {HotKeys} from 'react-hotkeys';
const keyMap = {
  // 'save': 'command+s',
};

import * as firebase from 'firebase'
firebase.initializeApp({
  apiKey: "AIzaSyBQ_a8wbhKvgJhzBedt_su0bfqRM7HIN3E",
  authDomain: "assettracker-f7d45.firebaseapp.com",
  databaseURL: "https://assettracker-f7d45.firebaseio.com",
  storageBucket: "assettracker-f7d45.appspot.com",
  messagingSenderId: "520777767369"
});

var provider = new firebase.auth.GoogleAuthProvider();
provider.addScope('profile');
provider.addScope('email');
// provider.setCustomParameters({
//   'display': 'popup'
// });

import AccountListItem from './AccountListItem';
import Account from './Account';
import NewButtonDialog from './NewButtonDialog';

class App extends Component {
  constructor(props){
    super(props);
    this.state = {
      showDrawer: false,
      user: null,
      accounts: {},
      selectedAccount: null,
    }

    firebase.auth().onAuthStateChanged((user) => {
      const userAttrs = user ? ['displayName', 'email', 'photoURL', 'providerId', 'uid'].reduce((o, k) => {o[k] = user[k]; return o;}, {}) : null;

      this.setState({
        user: userAttrs,
        accounts: null,
        selectedAccount: null,
      });

      if(user){
        this.userRef     = firebase.database().ref().child('users').child(user.uid);
        this.accountsRef = firebase.database().ref().child('accounts').child(user.uid);

        this.userRef.update(userAttrs);
        this.userRef.on("value", (snap) => {
          this.setState({user: snap.val()});
        });

        const updateAccount = snap => {
          const accounts = {...this.state.accounts};
          if(snap.val().deleted_at){
            delete accounts[snap.key];
          }else{
            accounts[snap.key] = {...snap.val(), id: snap.key}
          }
          this.setState({accounts});
        };
        this.accountsRef.on("child_added", updateAccount);
        this.accountsRef.on("child_changed", updateAccount);
      }else{
        this.accountsRef.off();
        this.accountsRef = null;
      }
    });
  }

  login(){
    firebase.auth().signInWithPopup(provider)
    // .then(result => {
    //   const token = result.credential.accessToken;
    //   const user = result.user;
    // })
    .catch(error => {
      console.dir({error});
      // error.code, error.message
    });
  }

  logout(){
    firebase.auth().signOut().then(function() {
      // Sign-out successful.
    }, function(error) {
      console.error("Error logging out:")
      console.dir(error);
    });
  }

  render() {
    return (
      <MuiThemeProvider muiTheme={getMuiTheme(lightBaseTheme)}>
        <HotKeys keyMap={keyMap}>
          <div>
            <AppBar
              title="Asset Tracker"
              iconElementRight={
                this.state.user && this.state.user.displayName ?
                <FlatButton label={this.state.user.displayName} onTouchTap={this.logout.bind(this)} /> :
                <FlatButton label="Login" onTouchTap={this.login.bind(this)} />
              }
              onLeftIconButtonTouchTap={() => this.setState({showDrawer: true})}
            />

          {!this.state.user &&
              <Paper style={{padding: 30, flex: 1, margin: 50}} zDepth={1}>
                <center>
                  <p>Hello! This is a simple tool to keep track of your investments, and how much you've gained or lost on them.</p>
                  <p>It was made by <a href="http://christian.gen.co">Christian Genco</a>.</p>
                  <RaisedButton label="Sign up with Google" primary={true} onTouchTap={this.login.bind(this)} />
                </center>
              </Paper>
            }

            {this.state.user && <NewButtonDialog
              title="New Asset"
              onSubmit={data => {
                this.accountsRef.push({...data, records: {0: {"balance":10,"contribution":10,"date":1483250400000}, 1:{"balance":25,"contribution":10,"date":1483855200000}}})
                .then(res => this.setState({selectedAccount: res.key}));
              }}
            />}


            <div style={{display: 'flex'}}>
              {this.state.user &&
                <div style={{flex: 1, height: "calc(100vh - 64px - 8px)"}}>
                  {Object.keys(this.state.accounts || {}).length === 0 &&
                    <Paper style={{padding: 30, flex: 1, margin: 50}} zDepth={1}>
                      <h1>You did it!</h1>
                      <p>Woohoo! Your account has been created. No passwords to remember or anything :D</p>

                      <p>Try out this tracker by importing a demo asset:</p>
                      <RaisedButton
                        label={`Import "Gold Nuggets" Demo Asset`}
                        primary={true}
                        onTouchTap={() => {
                          const demoAsset = {"name":"Gold Nuggets","records":{"1486961684917":{"balance":10,"contribution":10,"date":1483250400000},"1486961697116":{"balance":21,"contribution":10,"date":1483855200000},"1486961718269":{"balance":31,"contribution":10,"date":1484460000000},"1486961735970":{"balance":39,"contribution":10,"date":1485064800000},"1486961743695":{"balance":52,"contribution":10,"date":1485669600000}},"updatedAt":1486961800288,"id":"-KcpoeW1SqHwmbFjj_7c"};
                          this.accountsRef.push(demoAsset)
                          .then(res => this.setState({selectedAccount: res.key}));
                        }}
                      />
                    </Paper>
                  }
                  <List style={{overflow: 'scroll', height: "calc(100% - 48px - 8px)"}}>
                    {Object.keys(this.state.accounts || {}).map(account_id =>
                      <AccountListItem
                        account={this.state.accounts[account_id]}
                        key={account_id}
                        selected={this.state.selectedAccount === account_id}
                        onTouchTap={() => this.setState({selectedAccount: account_id})}
                      />
                    )}
                    <div style={{height: "60px"}} />
                  </List>
                </div>
              }

              {this.state.user && this.state.selectedAccount &&
                <Account
                  account={this.state.accounts[this.state.selectedAccount]}
                  id={this.state.selectedAccount}
                  update={params => this.accountsRef.child(this.state.selectedAccount).update({...params, updatedAt: +new Date()})}
                  firebaseRef={this.accountsRef.child(this.state.selectedAccount)}
                />
              }
            </div>

            <Drawer
              docked={false}
              width={200}
              open={this.state.showDrawer}
              onRequestChange={(showDrawer) => this.setState({showDrawer})}
            >
              <MenuItem onTouchTap={() => this.setState({showDrawer: false, showEditTemplate: true})}>Edit Note Template</MenuItem>
            </Drawer>

          </div>
        </HotKeys>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js